
import getters   from './getters'
import actions   from './actions'
import mutations from './mutations'

const state = {
  id: '',
  bulletinNotifications: [],
  generalDocumentNotifications: [],
  legalDocumentNotifications: [],
  paymentSlipNotifications: [],
  paymentSlipLateNotifications: [],
  paymentSlipAnticipationNotifications: [],
  eventNotifications: [],
  visualized: {},
  loading: false
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/notifications/index.js